import { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import './AdminLayout.css';

const NAV = [
  { to: '/admin/dashboard', icon: '📊', label: 'Dashboard' },
  { to: '/admin/shops',     icon: '👥', label: 'Winkeliers' },
  { to: '/admin/deals',     icon: '🏷️', label: 'Deals' },
  { to: '/admin/areas',     icon: '🗺️', label: 'Gebieden' },
  { to: '/admin/invoices',  icon: '🧾', label: 'Facturen' },
  { to: '/admin/tokens',    icon: '🎫', label: 'Tokens' },
  { to: '/admin/packages',  icon: '📦', label: 'Pakketten' },
  { to: '/admin/stats',     icon: '📈', label: 'Statistieken' },
  { to: '/admin/settings',  icon: '⚙️', label: 'Instellingen' },
];

const MOBILE_NAV = NAV.slice(0, 4);

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('walkin_admin_mode') !== 'true') {
      navigate('/admin/login', { replace: true });
    }
  }, [navigate, location.pathname]);

  const adminName = sessionStorage.getItem('walkin_admin_name') || 'Admin';
  const adminRole = sessionStorage.getItem('walkin_admin_role') || '';

  const handleLogout = () => {
    sessionStorage.removeItem('walkin_admin_mode');
    sessionStorage.removeItem('walkin_admin_name');
    sessionStorage.removeItem('walkin_admin_role');
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="admin">
      <aside className="admin__sidebar">
        <div className="admin__brand">
          <div className="admin__brand-logo">
            <span className="admin__brand-walk">Walk</span>
            <span className="admin__brand-in">In</span>
          </div>
          <div className="admin__brand-badge">Admin Panel</div>
        </div>

        <nav className="admin__nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                'admin__nav-item' + (isActive ? ' admin__nav-item--active' : '')
              }
              end={item.to === '/admin/dashboard'}
            >
              <span className="admin__nav-icon">{item.icon}</span>
              <span className="admin__nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="admin__sidebar-foot">
          <div className="admin__sidebar-user">
            <div className="admin__sidebar-name">{adminName}</div>
            <div className="admin__sidebar-role">{adminRole}</div>
          </div>
          <button className="admin__logout" onClick={handleLogout}>
            Uitloggen
          </button>
        </div>
      </aside>

      <main className="admin__main">
        <Outlet />
      </main>

      {/* Mobile bottom nav */}
      <nav className="admin__bottom-nav">
        {MOBILE_NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              'admin__tab' + (isActive ? ' admin__tab--active' : '')
            }
            end={item.to === '/admin/dashboard'}
          >
            <span className="admin__tab-icon">{item.icon}</span>
            <span className="admin__tab-label">{item.label}</span>
          </NavLink>
        ))}
        <button
          className={'admin__tab' + (drawerOpen ? ' admin__tab--active' : '')}
          onClick={() => setDrawerOpen(true)}
          type="button"
        >
          <span className="admin__tab-icon">⋯</span>
          <span className="admin__tab-label">Meer</span>
        </button>
      </nav>

      {drawerOpen && (
        <div
          className="admin__drawer-backdrop"
          onClick={() => setDrawerOpen(false)}
        >
          <div className="admin__drawer" onClick={(e) => e.stopPropagation()}>
            <div className="admin__drawer-title">Menu</div>
            {NAV.slice(4).map((item) => (
              <button
                key={item.to}
                className="admin__drawer-item"
                onClick={() => {
                  navigate(item.to);
                  setDrawerOpen(false);
                }}
              >
                <span>{item.icon}</span>
                <span>{item.label}</span>
              </button>
            ))}
            <button
              className="admin__drawer-item admin__drawer-item--logout"
              onClick={handleLogout}
            >
              <span>🚪</span>
              <span>Uitloggen</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
